<button
  class="font-semibold h-[48px] rounded-lg flex flex-nowrap justify-center items-center cursor-pointer text-sm p-3"
  type="button"
  [ngClass]="{
    'text-[#333333] bg-[#F6CD4D]': variation() === 'primary',
    'text-[#333333] bg-[#FFF] border border-[#000]': variation() === 'tertiary',
    'pointer-events-none opacity-40': isDisable(),
  }"
  (click)="emitClickEvent($event)"
>
  <ng-content></ng-content>
  {{ text() }}
</button>
